import events from "_src/engine/events";
import objFactory from "_src/engine/factories/object";
import primitiveFactory from "_src/engine/factories/primitive";
import minmaxUtils from "_src/engine/utility/minmax";
import { primitiveType } from "_src/engine/constants";
import LineShader from "_src/shaders/line/line";

import objState from "_src/obj_state";

const bboxes = new Map();
const changedObjects = [];

export default {

  setVisibility(objects, isVisible, scene) {
    for (let bbox of bboxes.values()){
      scene.remove(bbox);
    }
    bboxes.clear();

    if (!isVisible) {
      return;
    }

    for (const object of objects) {
      if (!object.getVisibility()) {
        continue;
      }

      let bboxShader = new LineShader({lineWidth: 3, transparent: true});

      let bbox = objFactory.createDrawable(bboxShader);
      bbox.addGeometryChunk(primitiveFactory.create(primitiveType.AABOX));
      bbox.setDiffuseColor(0.4, 0.7, 0.9);

      for (let i = 0; i < bbox.chunks.length; ++i) {
        bbox.chunks[i].enableFrustumTest = false;
      }

      minmaxUtils.setMinmaxBuffer(bbox.chunks[0], object.getWorldMinmax());
      scene.add(bbox);
      bboxes.set(object, bbox);
    }
  },

  notifyThatMinMaxChanged(object) {
    object.setState(objState.OS_BOUNDING, false);
    changedObjects.push(object);
  },

  fastMinMaxRecalc(object) {
    minmaxUtils.recomputedFromRotated(object.getWorldMinmax(), object.getLocalMinmax(), object.model.modelMatrix);
    changedObjects.push(object);
  },

  processSizeChanges() {
    const objectsUpdated = [];
    for(let i = changedObjects.length -1; i >= 0 ; i--) {
      if(changedObjects[i].getState(objState.OS_BOUNDING)) {
        updateBBox(changedObjects[i], changedObjects[i].getWorldMinmax());
        objectsUpdated.push(changedObjects[i]);
        changedObjects.splice(i, 1);
      }
    }

    if (objectsUpdated.length === 0) {
      return false;
    }

    events.emit("object_bboxes_updated", objectsUpdated);
    return true;
  },

  cleanup() {
    bboxes.clear();
    changedObjects.length = 0;
  }
}

function updateBBox(object, minmax) {
  const bbox = bboxes.get(object);
  if (bbox) {
    minmaxUtils.setMinmaxBuffer(bbox.chunks[0], minmax);
  }
}
